/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */
import type { RefObject } from 'react';

import {
    TooltipContainerStyled,
    TooltipTitleStyled,
    TooltipHintMessageStyled,
} from '@components/common/Tooltip/styled/TooltipStyled';
import RenderInBody from '@modules/app/hoc/RenderInBody';

import {
    TableTooltipInnerBlockStyled,
    TableTooltipOuterBlockStyled,
} from '../../styled/TableTooltipStyled';

interface ITableTooltipProps {
    tooltipMessageRef: RefObject<HTMLSpanElement>;
    tooltipRef: RefObject<HTMLDivElement>;
    tooltipTextRef: RefObject<HTMLSpanElement>;
}

const TableTooltip = ({ tooltipMessageRef, tooltipRef, tooltipTextRef }: ITableTooltipProps) =>
    <RenderInBody>
        <TableTooltipOuterBlockStyled
            ref={tooltipRef}
        >
            <TableTooltipInnerBlockStyled>
                <TooltipContainerStyled maxWidth="280px">
                    <TooltipTitleStyled ref={tooltipTextRef}/>
                    <TooltipHintMessageStyled ref={tooltipMessageRef}/>
                </TooltipContainerStyled>
            </TableTooltipInnerBlockStyled>
        </TableTooltipOuterBlockStyled>
    </RenderInBody>;

export default TableTooltip;
